export default {
  sweet_alert: {
    default: {
      cancelButtonText: 'Cancel',
      cannot_exec_command: 'Can not exec command',
      confirmButtonText: 'Confirm',
      confirmDeleted: 'Your file has been deleted',
      confirmDeletedPaymentGateway: 'Your payment gateway was deleted',
      confirmResetPassword: 'Your password was regenerated',
      continueButtonText: 'Continue',
      defaultError: 'Something went wrong, please contact support.',
      defaultErrorTitle: 'Error',
      deleteButtonText: 'Delete',
      deleted: 'Deleted',
      email: 'email',
      error_dimension_text: 'the minimum image size is 200x200 and the maximum image size is 300x300',
      errorText: 'You cannot perform this action',
      errorTitle: 'Error',
      mailSended: 'Email Sended',
      mikrotik_not_linked: 'Mikrotik not linked',
      not_found: 'Something went wrong,  please contact support team',
      ping: 'Ping',
      searchDeleted: 'You Record has been deleted',
      text: 'You will not be able to recover it',
      are_you_sure_title: 'Are you sure?',
      text_deleteRecord: 'You will lose your searches',
      title: 'Are you sure?',
      text_delete_all_records: 'You will lose all your search records',
      title_delete_payment_gateway: "Are you sure you want to delete the customer's payment gateway?",
      title_delete_warehouse: 'Are you sure you want to delete the warehouse?',
      title_deleteRecord: 'Surely you want to delete your search log?',
      title_password_reset: 'Are you sure you want to regenerate the password?',
      title_publish: 'Are you sure you want to publish the news?',
      title_update_success: 'Updated successfully',
      titleSendMail: 'Send Test Mail',
      unauthorize: 'Unauthorize',
      unpenalize_mikrotik: 'Unpenalize Mikrotik',
      unlink: 'Unlink',
      service_error: 'Service not available, try later'
    },
    clients: {
      massive_destroy: {
        title: 'Massive remove',
        text: 'The clients will be removed <strong>including his contracts</strong>. You can find them using the "Removed" filter'
      }
    },
    cloud_license: {
      acs_license: {
        cannot_subscribe: "You cann't subscribe with a total less than or equal to $0",
        cannot_update_price: "You cann't upgrade with a price less than or equal to $0",
        default_error: 'The subscription could not be completed',
        delete_error: 'Failed to cancel the subscription',
        delete_loading_text: 'Cancelling the ACS subscription…',
        delete_successful: 'Subscription successfully cancelled',
        subscribe_loading_text: 'Processing ACS subscription…',
        text_confirm_subscribe_total: 'The subscription will be made for ${{total}}',
        text_confirm_subscribe_total_installation_price:
          'The subscription will be made for ${{total}} and an installation invoice will be generated for ${{installation_price}}',
        text_confirm_update_subscribe: 'The subscription will be updated',
        text_confirm_update_subscribe_total: 'The subscription will be updated for ${{total}}',
        text_success_subscribe: 'The subscription was successfully completed',
        title_confirm_subscribe: 'Do you want to subscribe to ACS?',
        title_delete_subscribe: 'Do you want to cancel your ACS subscription?',
        title_update_subscribe: 'Do you want update your subscription?',
        update_error: 'The subscription could not be updated',
        update_successful: 'Subscription updated successfully'
      },
      title_enable_internal_use: 'Enable ISP for internal use',
      title_disable_internal_use: 'Disable ISP for internal use',
      text_enable_internal_use: 'Do you want to enable the ISP for internal use?',
      text_disable_internal_use: 'Do you want to disable the ISP for internal use?',
      text_loading_internal_use: 'Applying change',
      text_success_internal_use: 'The change was completed successfully.',
      text_error_internal_use: 'The change could not be completed.',
      cancel_discount_trial_license:
        'By canceling your subscription, your discounts and trial period will end. The subscription will be canceled at the end of the current period.',
      cancel_license: 'Do you want to cancel your subscription?',
      cloud: {
        default_error: 'The installation could not be performed',
        install_loading_text: 'Processing billing...',
        text_confirm_subscribe_total_installation_price:
          'An installation invoice will be generated for ${{installation_price}}',
        text_success_subscribe: 'The invoice was successfully issued',
        title_confirm_install: 'Do you want to install Cloud?'
      },
      hola_suite: {
        cancel_send_text: 'Your notification will not be sent, are you sure?',
        cancel_send_title: 'Cancel sending',
        cannot_subscribe: 'You cannot subscribe with a total of $0.00',
        default_error: 'The subscription could not be completed',
        delete_error: 'Failed to cancel the subscription',
        delete_loading_text: 'Cancelling the Hola Suite subscription…',
        delete_successful: 'Subscription successfully cancelled',
        subscribe_loading_text: 'Processing Hola Suite subscription…',
        text_confirm_subscribe_total:
          'The subscription will be made for ${{total}} and an installation invoice will be generated for ${{installation_price}}',
        text_confirm_subscribe_total_installation_price:
          'The subscription will be made for ${{total}} and an installation invoice will be generated for ${{installation_price}}',
        text_confirm_update_subscribe: 'The subscription will be updated',
        text_confirm_update_subscribe_total: 'The subscription will be updated for ${{total}}',
        text_success_subscribe: 'The subscription was successfully completed',
        title_confirm_subscribe: 'Do you want to subscribe to Hola Suite?',
        title_delete_subscribe: 'Do you want to cancel your Hola Suite subscription?',
        title_update_subscribe: 'Do you want update your subscription?',
        update_error: 'The subscription could not be updated',
        update_successful: 'Subscription updated succesfully'
      },
      invoice: {
        finalize_loading_text: 'Trying to issue invoice...',
        payment_loading_text: 'Attempting to make the payment...',
        text_cannot_finalize: 'The invoice could not be issued',
        text_cannot_payment: 'Payment could not be completed',
        text_finalize_invoice:
          'The invoice {{number_invoice}} will be issued and and attempt will be made to charge the customer',
        text_pay_with_default_payment_method:
          'The payment will be made using the default payment method ({{brand}} ending in {{last_four_numbers}})',
        text_success_finalize: 'The invoice was issued completed',
        text_success_payment: 'Payment was successfully completed',
        title_confirm_finalize: 'Do you want to issue this invoice?',
        title_confirm_payment: 'Do you want to make a payment?'
      },
      reactivate_suscription_successful: 'The subscription was re subscribed successfully',
      something_wrong: 'Something went wrong',
      text_confirm_reactivate_suscription: 'We are going to re subscribe the subscription with a 2-day trial',
      title_reactivate_suscription: 'Do you want to re subscribe the subscription?',
      unlock_plan: 'Do you want to unlock the plan?',
      update_loading_text: 'We are re subscribing the license'
    },
    contracts: {
      confirmDeleted: 'The contract has been deleted',
      need_ip_and_server: 'Need a valid IP and Server to check the MAC address',
      need_ip_and_server_and_interface: 'Need a valid IP, Server and Interface to check the MAC address',
      massive_unlink_title: 'Massive unlink ONUs',
      title_with_ont: 'Delete contract and unauthorize ONT',
      text_with_ont:
        'This contract has an associated ONT. By deleting it, the ONT will be unauthorized. Do you want to continue?',
      authorize_ont: {
        authorize: 'Authorize ONU',
        title: 'Do you want to authorize an ONU?',
        text: 'The contract, {{contract}}, is associated with the OLT {{olt}} but does not have an ONU associated.'
      }
    },
    isps: {
      regen_token: {
        regenToken: 'Token regenerated',
        text: 'You will not be able to recover the previous token',
        title: 'Are you sure?',
        errorText: `You can't upload 10mb image`
      },
      update: {
        text: 'Page will be refreshed to display the new data'
      },
      archive: {
        title: 'Archive ISP?',
        text: 'By archiving the ISP "{{name}}" the ISPs name and all employees email addresses will be changed.',
        confirm: 'Yes, archive'
      },
      archive_error: {
        title: 'Error archiving ISP',
        text: 'Try again later or contact support.',
        text_with_error: '{{error}}'
      }
    },
    naps: {
      destroy_close_button_text: 'Close',
      destroy_loading_text: 'Deleting NAP',
      destroy_error_title: 'Error deleting NAP'
    },
    nas: {
      confirmDeleted: 'The Nas has been deleted'
    },
    notifications: {
      title: 'Are you sure?',
      text: 'You will not be able to revert this!',
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Delete'
    },
    notification_smses: {
      title: 'Enter the destination number',
      placeholder: 'Number with country code',
      buttonSend: 'Send'
    },
    olt: {
      apply_changes: 'Apply Changes',
      authorize_ont_successfully: 'The ONU was successfully authorized',
      disable_catv_ont_succesfully: 'CATV was successfully disabled',
      enable_catv_ont_succesfully: 'CATV was successfully enabled',
      disable_wan_access_succesfully: 'WAN access was successfully disabled',
      enable_wan_access_succesfully: 'WAN access was successfully enabled',
      factory_reset_succesfully: 'ONU factory reset was successfully completed',
      link_ont_successfully: 'The ONU was successfully linked',
      link: 'Link',
      olt_online: 'OLT online',
      olt_offline: 'OLT offline',
      ont_authorized_succesfully: 'ONU successfully authorized',
      ont_authorized_text: 'Important authorization details:',
      ont_linked_succesfully: 'ONU successfully linked',
      ont_linked_text: 'Important link details:',
      reboot_ont_succesfully: 'ONU successfully rebooted',
      reboot: 'Reboot ONU',
      reconfig_ont_succesfully: 'ONU configuration was successfully overwritten.',
      reconfigure_ont_succesfully: 'ONU configuration was successfully overwritten.',
      reconfig_wan_succesfully: 'WAN configuration was successfully overwritten.',
      resync_ont_successfully: 'ONU successfully resynchronized.',
      reconfigure_wan: 'Overwrite WAN configuration',
      reconfigure: 'Overwrite ONU configuration',
      unauth_ont_succesfully: 'The ONU was successfully unauthorized',
      unauth_ont_successfully: 'The ONU was successfully unauthorized',
      unauth: 'Unauthorize',
      unlink_ont_succesfully: 'The ONU was successfully unlinked from the contract',
      unlink: 'Unlink',
      resync: 'Resynchronization',
      connected: 'Connected',
      not_connected: 'Not connected',
      not_configured: 'Not configured',
      olt_connection_status: 'OLT connection status',
      connection_type: 'Connection type',
      autodiscover_onts: 'Autodiscover ONUs'
    },
    olt_server_interfaces: {
      autodiscover_refresh: 'Autodiscover refresh'
    },
    // ---> Las traducciones de sweet alerts de ONU/OLT van todas arriba, en la key: olt
    ont: {
      authorize_ont_successfully: 'The ONU was successfully authorized',
      authorize: 'Authorize',
      link_ont_successfully: 'The ONU was successfully linked',
      link: 'Link',
      reconfigure_ont_succesfully: 'ONU configuration was successfully overwritten.',
      reconfigure: 'Overwrite configuration',
      unauth: 'Unauthorize',
      unauthorizing: 'Unauthorizing the ONU, please wait.'
    },
    payment_gateways: {
      text_to_propagate:
        'In case of propagating the invoice report status it will affect all the customers associated to this gateway.'
    },
    plans: {
      confirmDeleted: 'Your plan has been deleted'
    },
    portal_configurations: {
      'file-too-large': `You can't upload 10mb image`,
      'file-invalid-type': 'Invalid format, allowed: .png, jpg, jpeg '
    },
    ppp_profiles: {
      confirmDeleted: 'Your PPP profile has been deleted'
    },
    push_notification: {
      add_all_clients_text: 'All Clients will be added',
      add_all_clients_title: 'Add Clients',
      all_clients_removed: 'All clients of this notification have been removed.',
      cant_add_clients: 'You cant add clients to this notification after 15 minutos, was already sent',
      cant_delete: 'You cant delete this notification after 15 minutos, was already sent',
      cant_edit: 'You cant edit this notification after 15 minutos, was already sent',
      clients_added_text: '{{count}} {{client}} were added to this notification',
      clients_added_title: 'Clients Added',
      clients_already_exits_text: 'There are no Clients to add to this Notification .',
      clients_not_found: 'There are no Clients with this search criteria',
      clients_removed: 'Removed Clients associated with this notification successfully.',
      need_clients: 'You need to select at least one client',
      no_clients_text: 'There are no Clients associated to this notification to remove',
      notification_deleted: 'The notification has been deleted',
      remove_all_clients_text: 'All Clients associated with this Notification will be removed.',
      remove_all_clients_title: 'Caution',
      remove_filtered_clients_text: '{{count}} {{client}} will be removed from notification',
      remove_filtered_clients_title: 'Remove',
      time_expired_text: 'you cant perform this action after 15 min pass',
      time_expired_title: 'Time Expired'
    },
    sale_desk: {
      source: {
        destroy_close_button_text: 'Close',
        destroy_loading_text: 'Deleting source',
        destroy_error_title: 'Error deleting source'
      },
      leads: {
        text: 'The associated <b>prospects</b> and <b>sale desk tickets</b> will be deleted.'
      },
      prospects: {
        text: 'The associated <b>sale desk tickets</b> and <b>orders</b> will be deleted.'
      },
      tags: {
        destroy_close_button_text: 'Close',
        destroy_loading_text: 'Deleting Tag',
        destroy_error_title: 'Error deleting Tag'
      }
    },
    server_configurations: {
      cant_connect_to_mikrotik: 'Cant connect to mikrotik',
      mikrotik_not_linked: 'Mikrotik not linked',
      need_clients: 'You need to select at least one client',
      no_clients_text: 'There are no Clients associated to this notification to remove',
      notification_deleted: 'The notification has been deleted',
      ping: 'Ping',
      remove_all_clients_text: 'All Clients associated with this Notification will be removed.',
      remove_all_clients_title: 'Caution',
      remove_filtered_clients_text: '{{count}} {{client}} will be removed from notification',
      remove_filtered_clients_title: 'Remove',
      resync: 'Resync',
      time_expired_text: 'you cant perform this action after 15 min pass',
      time_expired_title: 'Time Expired'
    },
    invoicing: {
      contract_discounts: {
        cancel_discount: {
          title: 'Are you sure?',
          text: 'You will not be able to revert this!',
          cancelButtonText: 'Cancel',
          confirmButtonText: 'Cancel discount'
        },
        delete_discount: {
          title: 'Are you sure?',
          text: 'You will not be able to revert this!',
          cancelButtonText: 'Cancel',
          confirmButtonText: 'Delete discount'
        }
      },
      discount: {
        enable: {
          title: 'Enable Discount?',
          text: 'By enabling the "{{name}}" discount, it will become visible and assignable to contracts',
          confirm: 'Yes, enable'
        },
        disable: {
          title: 'Disable Discount?',
          text: 'The discount "{{name}}" currently affects {{contractsToApply}} contracts',
          confirm: 'Yes, disable'
        }
      },
      drafts: {
        remove_drafts: {
          title: 'Are you sure you want to delete ALL drafts from the active filter?'
        }
      },
      payment_receipt: {
        change_state_to_discarded: {
          title: 'Are you sure?',
          text: 'The payment receipt state will change to discarded'
        },
        change_state_to_pending: {
          title: 'Are you sure?',
          text: 'The payment receipt state will return to pending'
        },
        change_state_to_processed: {
          title: 'Are you sure?',
          text: 'The payment receipt state will change to processed'
        },
        change_state_error: {
          title: 'Error updating payment receipt',
          text: 'Try again later or contact support'
        }
      },
      payment_transactions: {
        unbind: {
          title: 'Are you sure?',
          text: 'The payment transaction will be unbound from the invoice'
        },
        unbind_siigo: {
          title: 'Are you sure?',
          text: 'The payment transaction will be unbound from the invoice. <br><br><strong>IMPORTANT:</strong> Due to Siigo limitations, you must manually delete the cash receipt <strong>{{cash_receipt_name}}</strong> in Siigo',
          check_input: 'confirm that the cash receipt has been deleted in Siigo',
          input_validator_error: 'You must confirm that you deleted the cash receipt in Siigo before continuing'
        },
        unbind_error: {
          title: 'The payment transaction could not be unbound'
        },
        unbind_success: {
          title: 'The payment transaction was successfully unbound'
        }
      }
    },
    invoicing_configuration: {
      destroy_close_button_text: 'Close',
      destroy_error_title: 'Error deleting configuration',
      destroy_loading_text: 'Deleting configuration',
      'file-too-large': `You can't upload 10mb image`,
      'file-invalid-type': 'Invalid format, allowed: .png, jpg, jpeg '
    },
    tv_services: {
      directv_go: {
        cancel_subscription: {
          title: 'Are you sure you want to cancel the subscription?',
          subtitle: 'All the services will be cancelled at the end of month',
          title_card_input: 'Are you sure you want to cancel the Pack?',
          subtitle_card_input:
            'Canceling the basic plan means the inactivation of the subscription. The client will be able to enjoy the services they have until the end of the month when the inactivation becomes effective.'
        },

        cancel_subscription_success: {
          title: 'Subscription cancelled successfully'
        },

        cancel_subscription_error: {
          title: 'Error',
          subtitle: 'An error occurred while canceling the subscription. Try again later or contact support'
        },

        reset_password_success: {
          title: 'Password regenerated successfully',
          subtitle: 'An email will be sent to {{mail}} with the new password'
        },
        reset_password_error: {
          title: 'Error',
          subtitle: 'An error occurred while regenerating the password. Try again later or contact support'
        },

        reset_password: {
          title: 'Are you sure you want to regenerate the password?'
        },

        resync_subscription: {
          title: 'Are you sure you want to resync the subscription?',
          subtitle: 'The plans active in Wispro will be synchronized with DirectvGo'
        },

        resync_subscription_success: {
          title: 'Subscription synced successfully',
          subtitle: 'The plans in DirectvGo now match those in Wispro'
        },

        resync_subscription_error: {
          title: 'Error',
          subtitle: 'An error occurred while syncing the subscription. Try again later or contact support'
        }
      }
    }
  }
};
